import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/technological-transfer/_technologicalTransfer')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.technologicalTransfers' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
